import { useCalcPriceQuery } from "../../../api/queries/priceQueries";
import { PriceDataHelper } from "../../../components/booking-card/PriceDataHelper";
import PriceRowArea from "../../../components/booking-card/PriceRowArea";
import { mappingBookingState2RequestDTO } from "../../../mapping/mappingBookingState2RequestDTO";
import { splitBookingBasedOnAge } from "../../../utils/bookingUtils";

export const CartRowQuantity = (props: {
  bookingState: SelectableBooking;
  vari: "READONLY" | "EDIT";
}) => {
  const { bookingState } = props;
  const bookingPrice = useCalcPriceQuery([
    mappingBookingState2RequestDTO(bookingState),
  ]);

  const priceDataHelper = new PriceDataHelper(
    splitBookingBasedOnAge(bookingState),
    bookingPrice.data?.priceOfSingleBookings,
  );
  // const priceItDisplay = usePriceItDisplay();
  // const { priceIts } = PriceUtils.summary(bookingState, priceOfBooking);
  return (
    <>
      <PriceRowArea opts={["CART"]} priceDataHelper={priceDataHelper} />
      {/* {priceItDisplay.dp({ priceIts }).map(({ key, originalAmount, label }) => {
        if (
          bookingState?.product?.productType === "SIM" &&
          originalAmount === 0 &&
          key !== "SIM"
        ) {
          return null;
        }
        return (
          <CartRowQuantityPicker
            key={key}
            {...props}
            label={label}
            value={originalAmount}
          />
        );
      })} */}
    </>
  );
};
